import { breakpointValues } from "@magicbi/ui-library";
import { useMediaQuery } from "./useMediaQuery";

/** Device class of the viewport: phone < md (768), tablet md to < lg (992), desktop >= lg. */
export type ViewportClass = "phone" | "tablet" | "desktop";

/** Bare media queries; the max side is one pixel under the next breakpoint so the classes never overlap. */
export const VIEWPORT_QUERIES = {
  phone: `(max-width: ${breakpointValues.md - 1}px)`,
  tablet: `(min-width: ${breakpointValues.md}px) and (max-width: ${breakpointValues.lg - 1}px)`,
} as const;

/**
 * The one place that decides phone / tablet / desktop. Built on `useMediaQuery`, so the first render is
 * already right and a resize across a boundary re-renders. Without `matchMedia` (jsdom) it reports desktop.
 */
export const useViewportClass = (): ViewportClass => {
  const isPhone = useMediaQuery(VIEWPORT_QUERIES.phone);
  const isTablet = useMediaQuery(VIEWPORT_QUERIES.tablet);
  if (isPhone) return "phone";
  if (isTablet) return "tablet";
  return "desktop";
};
